// Florist line: dawn card, halo, falling petals, signature written by a pen mask.
// Without JS (or with reduced motion) everything stays visible as is.
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-cb-mk]').forEach((root) => {
    const strokes = [...root.querySelectorAll('[data-cb-sig-strokes] path')].map((p) => ({ p, len: p.getTotalLength(), x: p.getBBox().x }));
    strokes.sort((a, b) => a.x - b.x);
    const petal = root.querySelector('[data-cb-sig-petal]');
    strokes.forEach((o) => { o.p.style.strokeDasharray = o.len; o.p.style.strokeDashoffset = o.len; });
    if (petal) petal.style.opacity = 0;
    root.classList.add('is-armed');

    const write = () => {
      const total = strokes.reduce((a, o) => a + o.len, 0);
      let t = 1300;
      strokes.forEach((o) => {
        const dur = Math.max(50, 1300 * o.len / total);
        o.p.animate([{ strokeDashoffset: o.len }, { strokeDashoffset: 0 }], { duration: dur, delay: t, fill: 'both' });
        t += dur * 0.85;
      });
      if (petal) {
        const x = +petal.dataset.x, y = +petal.dataset.y;
        petal.animate([
          { opacity: 0, transform: `translate(${x - 120}px,${y - 600}px) rotate(80deg)` },
          { opacity: 1, transform: `translate(${x + 60}px,${y - 270}px) rotate(-10deg)`, offset: 0.45 },
          { opacity: 1, transform: `translate(${x}px,${y}px) rotate(-35deg)` }
        ], { duration: 900, delay: t, fill: 'both', easing: 'ease-in-out' });
      }
    };

    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      root.classList.add('is-play');
      write();
    }, { threshold: 0.4 });
    io.observe(root);
  });
})();
